import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import axios from 'src/utils/axios';
import { safeRequestParam } from 'src/utils/Common';
import logger from 'src/utils/logger';

function BasvuruNedeniSearch({ setModel, value, searchParam, modelKodu }) {
    const [openBN, setOpenBN] = React.useState(false);
    const [optionsBN, setOptionsBN] = React.useState([]);
    const loadingBN = openBN && optionsBN.length === 0;
    const [searchBN, setSearchBN] = React.useState('');

    React.useEffect(() => {
        let activeBN = true;
        if (openBN) {
            axios.get(`/GetArtemisIssueByProduct/${(safeRequestParam(searchBN) || 'a').toString().toLocaleLowerCase('tr-TR')}/${modelKodu}`)
            // axios.get(`/GetArtemisIssue/${(searchBN || ' ').toString().toLocaleLowerCase('tr-TR')}`)
                .then(res => {
                    if (activeBN) {
                        if (res.data) {
                            setOptionsBN(res.data);
                        } else {
                            setOptionsBN([]);
                        }
                    }
                }).catch(error => {
                    setOptionsBN([]);
                    logger.error("Hata detayı:", error.message);
                });
        }
        return () => {
            activeBN = false;
        };
    }, [searchBN, openBN, loadingBN, modelKodu]);

    React.useEffect(() => {
        if (searchParam.length > 0) {
            setSearchBN(searchParam);
        }
    }, [searchParam]);

    const updateModel = model => {
        setModel(model);
        value.ACIKLAMA = model.ACIKLAMA;
    }

    return (
        <Autocomplete
            id="asynchronous-demo"
            open={openBN}
            value={value?.ACIKLAMA ? value : null}
            onOpen={() => {
                setOpenBN(true);
            }}
            onClose={() => {
                setOpenBN(false);
            }}
            getOptionLabel={(option) => { return option?.ACIKLAMA || '' }}
            getOptionSelected={(option, value) => option?.ACIKLAMA === value?.ACIKLAMA}
            options={optionsBN}
            filterOptions={(optionsBN) => optionsBN}
            loading={loadingBN}
            onChange={(event, newValue) => {
                if (newValue && newValue.ACIKLAMA) {
                    updateModel(newValue);
                }
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth
                    onChange={e => setSearchBN(e.target.value)}
                    variant="outlined"
                    helperText={value ? value.ACIKLAMA : ''}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loadingBN ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
}

export default BasvuruNedeniSearch;
